import cn from "classnames";
import React from "react";

import ksIcon from "./../ksIcon";

import styles from "./JournalActingKsIcon.module.scss";

interface IProps {
  act: { title: string } | null;
  onClick: (value: boolean) => void;
  prefix: string;
}

const JournalActingKsIcon = ({ act, onClick, prefix }: IProps) => {
  if (!act) return null;

  return (
    <div
      className={cn(styles.ks, { [styles.activeKs]: act })}
      //
      title={act?.title}
      onClick={() => act && onClick(true)}
    >
      {/*  {ksIcon} */}
      <span>
        {prefix}
        {act?.title}
      </span>
    </div>
  );
};

export default JournalActingKsIcon;
